export const SET_EMAIL = 'SET_EMAIL';
export const SET_PHONE = 'SET_PHONE';
export const SET_IS_PHONE_ACCOUNT = 'SET_IS_PHONE_ACCOUNT';

export const SET_ROUTE = 'SET_ROUTE';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const SET_NOTIFICATION_FUNCTION = 'SET_NOTIFICATION_FUNCTION';